import { Organization } from './types'
import { CreateOrUpdateOrganizationParam } from '../volunteering/organizations/models'

export function omitAdminLocaleFields<T extends Record<string, unknown>>(payload: T): T {
  const { supportedAdminLocales, defaultAdminLocale, ...rest } = payload as CreateOrUpdateOrganizationParam & T
  return rest as T
}

export function mapOrgToPayload(organization: Organization): CreateOrUpdateOrganizationParam {
  const { address: existingAddress, location, ...rest } = organization

  let address: any
  if (location && location.coordinates && existingAddress) {
    const [lng, lat] = location.coordinates
    address = { ...existingAddress, gps: { lat, lng } }
  }
  return {
    ...rest,
    address,
  }
}
